import { NullTemplateVisitor } from '@angular/compiler';
import { Component, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, NgModel } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelect } from '@angular/material/select';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { merge, Observable } from 'rxjs';
import { map, startWith, tap } from 'rxjs/operators';
import { AlertsCenterService } from 'src/app/core/services/alerts-center.service';
import { StatiEvento } from 'src/app/model/StatiEvento.enum';
import { EntiService } from 'src/app/services/enti.service';
import { EventiService } from 'src/app/services/eventi.service';
import { InterventiDataSource } from 'src/app/services/interventi.datasource';
import { InterventiService } from 'src/app/services/interventi.service';
import { RichiesteDgpeService } from 'src/app/services/richieste-dgpe.service';
import { Toolbar, ToolbarEvent } from 'src/app/shared/components/toolbar/toolbar';
import { CambioStatoDialogComponent } from '../cambio-stato-dialog/cambio-stato-dialog.component';

export enum StatiIntervento {
  IN_ATTESA_DI_FINANZIAMENTO = "ATTFIN",
  PREVENTIVAMENTE_RESPINTO = "PRERES",
  IDONEO = "IDONEO",
  IN_PROPOSTA_DI_FINANZIAMENTO = "PROFIN",
  RESPINTO = "RESPIN",
  FINANZIATO = "FINANZ",
  ESPUNTO = "ESPUNT",
  IN_ATTESA_DI_LIQUIDAZIONE = "ATTLIQ",
  LIQUIDATO = "LIQUID",
}

@Component({
  selector: 'app-elenco-interventi',
  templateUrl: './elenco-interventi.component.html',
  styleUrls: ['./elenco-interventi.component.css']
})
export class ElencoInterventiComponent implements OnInit {

  dataSource: InterventiDataSource;
  arrowFlag: boolean = false;
  public form: FormGroup;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('orderBy') orderBy: MatSelect;
  select: boolean = false;
  risultatiPerPagina: number = 10;
  operazioni: ModelEventiCalamitosi.OperazioniInterventi[];
  showCheckboxes: boolean = false;
  abilitaCheckbox: boolean = false;
  isDettaglio: boolean;
  isDettaglioToolbar: boolean;
  isModifica: boolean;
  priorita: ModelEventiCalamitosi.PrioritaDto[] = [];
  ocdpc: String;
  controlList: ModelEventiCalamitosi.InterventoDtoElenco[] = [];
  operazioneSuTutti: string = "";
  operazioneDaEffettuare: number;
  filteredEnti: Observable<ModelEventiCalamitosi.EnteDto[]>;
  confirmed: string;
  enti: ModelEventiCalamitosi.EnteDto[] = [];
  idRichiesta: number;

  ente: ModelEventiCalamitosi.EnteDto = {
    idEnte: null,
    descrizione: null,
    abilitato: null,
    modificato: null,
    nodeCode:null,
  };

  interventiSearchableDto: ModelEventiCalamitosi.InterventoSearchableDto = {
    idIntervento: null,
    codiceIntervento: null,
    dpgr: null,
    stato: null,
    idEnte: null,
    descrIntervento: null,
    idStatoProgetto: null,
    idStatoEsecuzione: null,
    localita: null,
    enteAttuatore: null,
    idPriorita: null,
    importoComplRichiestoDa: null,
    importoComplRichiestoA: null,
    importoSpeseSostenuteDa: null,
    importoSpeseSostenuteA: null,
    dataInizioLavoriDa: null,
    dataInizioLavoriA: null,
    dataFineLavoriDa: null,
    dataFineLavoriA: null,
    ocdpc: null,
    ricerca: true
  };

  /**
   *
   *
   * @type {EventEmitter<ToolbarEvent>}
   * @memberof DataTableComponent
   */
  @Output()
  public onToolbarEvent: EventEmitter<ToolbarEvent> = new EventEmitter();

  isLoading: boolean = false;
  openToggle: number = 0;

  displayedColumns: string[] = [
    'codiceIntervento',
    'stato',
    'ente',
    'descrIntervento',
    'statoAttuazione',
    'importo',
    'actions',
  ];
  statoEvento: string = '';


  constructor(
    private route: ActivatedRoute,
    private interventiService: InterventiService,
    private richiesteService: RichiesteDgpeService,
    private entiService: EntiService,
    private eventiService: EventiService,
    private router: Router,
    public dialog: MatDialog,
    private alertsCenterService: AlertsCenterService) {

    this.isDettaglio = this.router.url.includes('dettaglio-richiesta') ? true : false;
    this.isDettaglioToolbar= this.router.url.includes('dettaglio-richiesta') ? true : false;
    this.isModifica = (this.router.url.includes('modifica-richiesta')) ? true : false;

    this.idRichiesta = this.route.snapshot.params['idRichiesta'];

    this.entiService.getEntiProfilatiList().subscribe(res => {
      this.enti = res
    })

    this.interventiService.getListaPriorita().subscribe(priorita => {
      this.priorita = priorita;
    }, err => {
      this.alertsCenterService.showAlert({
        message: err.error.esitoServizio.descrizioneEsito,
        type: 'danger',
        autoClosable: false,
      });
    })
    this.buildForm();
  }

  private buildForm(): void {
    let group = {
      codiceIntervento: new FormControl(null, null),
      dpgr: new FormControl(null, null),
      stato: new FormControl(null, null),
      idEnte: new FormControl(null, null),
      descrIntervento: new FormControl(null, null),
      idStatoEsecuzione: new FormControl(null, null),
      localita: new FormControl(null, null),
      enteAttuatore: new FormControl(null, null),
      idPriorita: new FormControl(null, null),
      importoComplRichiestoDa: new FormControl(null, null),
      importoComplRichiestoA: new FormControl(null, null),
      importoSpeseSostenuteDa: new FormControl(null, null),
      importoSpeseSostenuteA: new FormControl(null, null),
      dataInizioLavoriDa: new FormControl(null, null),
      dataInizioLavoriA: new FormControl(null, null),
      dataFineLavoriDa: new FormControl(null, null),
      dataFineLavoriA: new FormControl(null, null),
      operazione: new FormControl(null, null)
    }
    this.form = new FormGroup(group);
  }

  ngOnInit(): void {
    this.dataSource = new InterventiDataSource(this.interventiService);
    this.operazioni = this.interventiService.getOperazioni();
    //Siamo interessati alle sole prime sei operazioni
    this.operazioni = this.operazioni.slice(0, 6)
    this.eventiService.getEventoByRichiesta(this.idRichiesta).subscribe(res => {
      this.isDettaglio = true
      res.forEach(ev => {
        if(ev.stato != StatiEvento.RACCOLTA_DATI_PE) {
          this.isDettaglio = false
          return
        }
      })
    })
    this.filteredEnti = this.form.controls.idEnte.valueChanges.pipe(startWith(''), map(value => this._filter(value))
    );
    this.dataSource.errors$.subscribe(res => {
      if (res) this.alertsCenterService.showAlert({
        message: `Errore lettura dati`,
        type: 'danger',
        autoClosable: false
      });
    })
  }

  sendEnte(ente) {
    this.ente = ente
  }

  refreshForm() {
    this.form.controls.idEnte.reset();
    this.ente = {
      idEnte: null,
      descrizione: null,
      abilitato: null,
      modificato: null,
      nodeCode:null
    };
  }

  private _filter(value): ModelEventiCalamitosi.EnteDto[] {
    if (value != null) {
      const filterValue = value.toLowerCase();
      return this.enti.filter(option => option.descrizione.toLowerCase().includes(filterValue) === true);
    }
  }

  //rimane in ascolto: se il click non è fatto sull'icona chiude il menù
  @HostListener('document:click', ['$event'])
  documentClick(event) {
    if (event.srcElement.innerText !== 'more_horiz') this.openToggle = 0;
  }

  ngAfterViewInit() {
    setTimeout(() => {

      this.richiesteService.getRichiestaById(this.idRichiesta).subscribe(ric => {
        this.interventiSearchableDto.ocdpc = ric.ocdpc;
        this.ocdpc = ric.ocdpc;
        this.interventiSearchableDto.ocdpc = this.ocdpc;
        this.dataSource.loadInterventi('', this.controlList, this.operazioneSuTutti, this.interventiSearchableDto, 'codiceIntervento,DESC', 0, this.risultatiPerPagina);
      })



      this.form.valueChanges.subscribe(() => this.paginator.pageIndex = 0);
      this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

      merge(this.sort.sortChange, this.paginator.page)
        .pipe(
          tap(() => {
            this.ricercaListaInterventi(true);
          }))
        .subscribe();

      this.dataSource.counter$
        .pipe(
          tap((count) => {
            this.paginator.length = count;
          })
        )
        .subscribe();

      this.form.controls.operazione.valueChanges.subscribe(op => {
        if (op !== undefined) {
          // qui chiamerò una funzione ad-hoc per filtrare
          // le istanze in base allo stato e alla operazione
          this.displayedColumns = [
            'operazione',
            'codiceIntervento',
            'stato',
            'ente',
            'descrIntervento',
            'statoAttuazione',
            'importo',
            'actions',
          ];
          this.ricercaListaInterventi(false);
        } else {
          this.onReset();
        }
      })

    });
  }

  public ricercaListaInterventi(ricerca: boolean, resetPage?: boolean): void {
    let statoPossibilePerOperazione = this.form.controls['stato'].value !== "" ? this.form.controls['stato'].value : null;
    if (this.form.controls.operazione !== undefined) {
      // in base all'operazione farò una ricerca filtrata
      let op = +this.form.controls['operazione'].value
      this.operazioneDaEffettuare = op
      if (op == 1) {
        statoPossibilePerOperazione = StatiIntervento.IN_ATTESA_DI_FINANZIAMENTO
      } else if (op == 2) {
        statoPossibilePerOperazione = StatiIntervento.IN_ATTESA_DI_FINANZIAMENTO
      } else if (op == 3) {
        statoPossibilePerOperazione = StatiIntervento.IDONEO
      } else if (op == 4) {
        statoPossibilePerOperazione = StatiIntervento.IN_PROPOSTA_DI_FINANZIAMENTO
      } else if (op == 5) {
        statoPossibilePerOperazione = StatiIntervento.IN_PROPOSTA_DI_FINANZIAMENTO
      } else if (op == 6) {
        statoPossibilePerOperazione = StatiIntervento.FINANZIATO
      }
    }
    this.interventiSearchableDto = {
      idIntervento: null,
      codiceIntervento: this.form.controls['codiceIntervento'].value !== "" ? this.form.controls['codiceIntervento'].value : null,
      dpgr: this.form.controls['dpgr'].value !== "" ? this.form.controls['dpgr'].value : null,
      stato: statoPossibilePerOperazione,
      idEnte: this.ente.idEnte,
      descrIntervento: this.form.controls['descrIntervento'].value !== "" ? this.form.controls['descrIntervento'].value : null,
      idStatoProgetto: null,
      idStatoEsecuzione: this.form.controls['idStatoEsecuzione'].value !== "" ? this.form.controls['idStatoEsecuzione'].value : null,
      localita: this.form.controls['localita'].value !== "" ? this.form.controls['localita'].value : null,
      enteAttuatore: this.form.controls['enteAttuatore'].value !== "" ? this.form.controls['enteAttuatore'].value : null,
      idPriorita: this.form.controls['idPriorita'].value !== "" ? this.form.controls['idPriorita'].value : null,
      importoComplRichiestoDa: this.form.controls['importoComplRichiestoDa'].value !== "" ? this.form.controls['importoComplRichiestoDa'].value : null,
      importoComplRichiestoA: this.form.controls['importoComplRichiestoA'].value !== "" ? this.form.controls['importoComplRichiestoA'].value : null,
      importoSpeseSostenuteDa: this.form.controls['importoSpeseSostenuteDa'].value !== "" ? this.form.controls['importoSpeseSostenuteDa'].value : null,
      importoSpeseSostenuteA: this.form.controls['importoSpeseSostenuteA'].value !== "" ? this.form.controls['importoSpeseSostenuteA'].value : null,
      dataInizioLavoriDa: this.form.controls['dataInizioLavoriDa'].value !== "" ? this.form.controls['dataInizioLavoriDa'].value : null,
      dataInizioLavoriA: this.form.controls['dataInizioLavoriA'].value !== "" ? this.form.controls['dataInizioLavoriA'].value : null,
      dataFineLavoriDa: this.form.controls['dataFineLavoriDa'].value !== "" ? this.form.controls['dataFineLavoriDa'].value : null,
      dataFineLavoriA: this.form.controls['dataFineLavoriA'].value !== "" ? this.form.controls['dataFineLavoriA'].value : null,
      ocdpc: this.ocdpc,
      ricerca:ricerca
    }
    if (this.checkData() && this.checkImportInterval()) {
      this.dataSource.loadInterventi('', this.controlList, this.operazioneSuTutti, this.interventiSearchableDto, this.sort.active + "," + this.sort.direction, this.paginator.pageIndex, this.paginator.pageSize);
    }
  }

  private replaceDotWithComma(value: number): string {
    if (value !== null) {
      let val = value.toFixed(2).toString();
      return val.replace(".", ",");
    }
  }

  sendIntervento(intervento) {
    let present = false;
    this.controlList.forEach((element, index) => {
      if (element.idIntervento === intervento.idIntervento) {
        this.controlList.splice(index, 1);
        present = true;
      }
    });
    if (!present) this.controlList.push(intervento);
  }

  setAll(checked) {
    if (checked === true) {
      this.operazioneSuTutti = 'S'
    } else {
      this.operazioneSuTutti = ""
    }
    this.controlList = []
    this.dataSource.loadInterventi('', this.controlList, this.operazioneSuTutti, this.interventiSearchableDto, this.sort.active + "," + this.sort.direction, this.paginator.pageIndex, this.paginator.pageSize)
  }

  /**
 *
 *
 * @private
 * @memberof SearchComponent
 */
  public generateToolBar(stato): Toolbar {
    if (this.isDettaglioToolbar ||
        stato == StatiEvento.RACCOLTA_DATI_PE) {
      return {
        toolbarCss: 'toolbar-vertical',
        actions: [
          {
            btnTitle: 'Dettaglio',
            btnIconClass: 'article',
            btnActionEvent: 'detail',
            btnCssClass: 'btn btn-secondary'
          }
        ]
      }
    }  else {
      return {
        toolbarCss: 'toolbar-vertical',
        actions: [
          {
            btnTitle: 'Dettaglio',
            btnIconClass: 'article',
            btnActionEvent: 'detail',
            btnCssClass: 'btn btn-secondary'
          },
          {
            btnTitle: 'Modifica',
            btnIconClass: 'create',
            btnActionEvent: 'edit',
            btnCssClass: 'btn btn-secondary'
          }
        ]
      }
    }
  }

  public handleToolbarEvent(event: ToolbarEvent): void {
    this.onNavigate(event.event, event.data)
  }

  onNavigate(path: string, data?: ModelEventiCalamitosi.InterventoDtoElenco) {
    if (path === 'edit') this.router.navigate([this.router.url + '/modifica-intervento/' + data.idIntervento]);
    else if (path === 'detail') this.router.navigate([this.router.url + '/dettaglio-intervento/' + data.idIntervento]);
    else if (path === 'back') this.router.navigate([this.router.url.replace("/elenco-interventi", '')]);
  }

  showSelect() {
    this.select = !this.select;
  }

  openChangeStatointerventoDialog() {
    //inserire qui la configurazione della material dialog MatDialogConfig per dati e css
    if ((this.operazioneSuTutti === '' && this.controlList.length === 0) || this.dataSource.counter$.source['value'] === 0) {
      this.alertsCenterService.showAlert({
        message: 'Selezionare operazione e interventi',
        type: 'danger',
        autoClosable: false,
      });
    } else {
      const dialogConfig = new MatDialogConfig();
      let tipoVista = "elenco-interventi"
      dialogConfig.data = {
        tipoVista: tipoVista,
        operazione: this.form.controls.operazione.value
      }
      const dialogRef = this.dialog.open(CambioStatoDialogComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(result => {
        let res = result;
        if (res !== false) {
          this.eseguiSalvataggio(res['motivazioneOperazione'])
        }
      });
    }
  }

  eseguiSalvataggio(motivazione?:string) {
    this.interventiSearchableDto.stato = null
    this.interventiService.save(this.ocdpc.toString(), this.controlList, this.operazioneSuTutti, +this.operazioneDaEffettuare, this.interventiSearchableDto,motivazione).subscribe(res => {
      this.operazioneSuTutti = "";
      this.controlList = [];
      this.alertsCenterService.showAlert({
        message: 'Elenco interventi aggiornati con successo',
        type: 'success',
        autoClosable: false
      });
      this.onReset();
    }, err => {
      this.alertsCenterService.showAlert({
        message: err.error.esitoServizio.descrizioneEsito,
        type: 'danger',
        autoClosable: false,
      });
    });
  }

  onReset() {
    this.form.reset();
    this.controlList = [];
    this.operazioneSuTutti = "";
    this.ente = {
      idEnte: null,
      descrizione: null,
      abilitato: null,
      modificato: null,
      nodeCode:null
    };
    this.ricercaListaInterventi(true);
    this.displayedColumns = this.displayedColumns.slice(1, this.displayedColumns.length);
  }

  private checkData(): boolean {

    if (this.interventiSearchableDto.dataInizioLavoriDa && this.interventiSearchableDto.dataInizioLavoriA) {
      if (this.form.controls.dataInizioLavoriDa.value > this.form.controls.dataInizioLavoriA.value) {
        let message = "Data di inizio maggiore della data di fine"
        this.alertsCenterService.showAlert({
          message: message,
          type: 'danger',
          autoClosable: false
        });
        return false;
      }
    } else if (this.interventiSearchableDto.dataInizioLavoriA) {
      this.interventiSearchableDto.dataInizioLavoriDa = "1900-01-01"
    } else if (this.interventiSearchableDto.dataInizioLavoriDa) {
      this.interventiSearchableDto.dataInizioLavoriA = "4000-01-01"
    }

    if (this.interventiSearchableDto.dataFineLavoriDa && this.interventiSearchableDto.dataFineLavoriA) {
      if (this.form.controls.dataFineLavoriDa.value > this.form.controls.dataFineLavoriA.value) {
        let message = "Data di inizio maggiore della data di fine"
        this.alertsCenterService.showAlert({
          message: message,
          type: 'danger',
          autoClosable: false
        });
        return false;
      }
    } else if (this.interventiSearchableDto.dataFineLavoriA) {
      this.interventiSearchableDto.dataFineLavoriDa = "1900-01-01"
    } else if (this.interventiSearchableDto.dataFineLavoriDa) {
      this.interventiSearchableDto.dataFineLavoriA = "4000-01-01"
    }

    return true;
  }

  private checkImportInterval(): boolean {

    if (this.interventiSearchableDto.importoComplRichiestoDa && this.interventiSearchableDto.importoComplRichiestoA) {
      if (this.form.controls.importoComplRichiestoDa.value > this.form.controls.importoComplRichiestoA.value) {
        this.interventiSearchableDto.importoComplRichiestoDa = (this.form.controls.importoComplRichiestoDa.value).toFixed(2)
        this.interventiSearchableDto.importoComplRichiestoA = (this.form.controls.importoComplRichiestoA.value).toFixed(2)
        let message = "Importo complessivo richiesto iniziale maggiore di quello finale"
        this.alertsCenterService.showAlert({
          message: message,
          type: 'danger',
          autoClosable: false
        });
        return false;
      }
    } 
    else if (this.interventiSearchableDto.importoComplRichiestoA) {
      this.interventiSearchableDto.importoComplRichiestoDa = Number.MIN_SAFE_INTEGER
    } else if (this.interventiSearchableDto.importoComplRichiestoDa) {
      this.interventiSearchableDto.importoComplRichiestoA = Number.MAX_SAFE_INTEGER
    }

    if (this.interventiSearchableDto.importoSpeseSostenuteDa && this.interventiSearchableDto.importoSpeseSostenuteA) {
      if (this.form.controls.importoSpeseSostenuteDa.value > this.form.controls.importoSpeseSostenuteA.value) {
        this.interventiSearchableDto.importoSpeseSostenuteDa = (this.form.controls.importoSpeseSostenuteDa.value).toFixed(2)
        this.interventiSearchableDto.importoSpeseSostenuteA = (this.form.controls.importoSpeseSostenuteA.value).toFixed(2)
        let message = "Importo spese sostenute iniziale maggiore di quello finale"
        this.alertsCenterService.showAlert({
          message: message,
          type: 'danger',
          autoClosable: false
        });
        return false;
      }
    } 
    else if (this.interventiSearchableDto.importoSpeseSostenuteA) {
      this.interventiSearchableDto.importoSpeseSostenuteDa = Number.MIN_SAFE_INTEGER
    } else if (this.interventiSearchableDto.importoSpeseSostenuteDa) {
      this.interventiSearchableDto.importoSpeseSostenuteA = Number.MAX_SAFE_INTEGER
    }

    return true;
  }

//dbclick ---> Evento doppio click
}
